module.exports = __webpack_public_path__ + "media/images/clients_form_box_bg-1108fb59260228d84e1be4950c4814fa.png";